import { render, staticRenderFns } from "./AssemblyStep.vue?vue&type=template&id=1f95dbf8&scoped=true&"
import script from "./AssemblyStep.vue?vue&type=script&lang=js&"
export * from "./AssemblyStep.vue?vue&type=script&lang=js&"
import style0 from "./AssemblyStep.vue?vue&type=style&index=0&id=1f95dbf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f95dbf8",
  null
  
)

export default component.exports